import { render, staticRenderFns } from "./ProgressBar.vue?vue&type=template&id=15d47c50&scoped=true"
import script from "./ProgressBar.vue?vue&type=script&setup=true&lang=js"
export * from "./ProgressBar.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ProgressBar.vue?vue&type=style&index=0&id=15d47c50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d47c50",
  null
  
)

export default component.exports